module.exports = __webpack_public_path__ + "media/images/soar/site/bg_default-a279efcd8cf4575427b5a6e39bcdd05d.svg";